<template>
  <div class="subproject-group">
      <div class="group h48 bg-fa flex-start-center cursor-p text-no-select mb4" @click="resizeH">
      <yxt-svg
        :class="{'vb-hidden' : num === 0}"
        class="flex-shrink-0  text-26 ml12"
        :icon-class="checkStatus ? 'down' : 'right'"
        width="20px"
        height="20px"/>
      <div class="c-26 font-size-14 font-bold max-800 ellipsis ml12 mr16">{{ title }}</div>
    </div>
    <div v-show="show"
         ref="wrapRef"
         class="group-drop-tran over-hidden"
         @transitionend="onTransitionEnd">
      <div ref="unfoldRef" class="pl32">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import foldMixins from './index';
export default {
  props: {
    title: String,
    num: {
      type: Number,
      default: 0
    }
  },
  mixins: [foldMixins],
  methods: {
    resizeH() {
      if (!this.num) return;
      this.resizeHeight();
    }
  }
};
</script>
